module.exports = __webpack_public_path__ + "assets/images/magenta_sport_9.03e0e0755544fa7a368ee5ce49cad782.png";